//* * this file should be modified only by you */
// import type { WritableComputedRef } from 'vue'
import type { CustomStoreImplementation, CustomStoreImplementationInstance } from 'kapix-components-vue3'
import { navigateTo } from 'kapix-components-vue3'
import type { StateTree, _GettersTree } from 'pinia'
import type { homePageRaw } from './store'

type HomePageStore = ReturnType<typeof homePageRaw>
function defineCustomStoreImplementation<S extends StateTree = {}, G extends _GettersTree<S> = {}, A = {}> (options: CustomStoreImplementation<HomePageStore, S, G, A>) {
  return {
    instance: options as CustomStoreImplementationInstance<HomePageStore, S, G, A>,
    options
  }
}

export default defineCustomStoreImplementation({
  state: () => {
    return {
      // custom state here
    }
  },
  getters: {
    // // ** EXAMPLE ** //
    // myCustomGetter (): WritableComputedRef<Nullable<string>> {
    //   return computed({
    //     get: () => this.$title,
    //     set: (value) => {
    //       this.$title = value
    //     }
    //   })
    // }
  },
  actions: {
    jeMinscrisClick () {
      navigateTo({ name: 'Experts' })
    },
    jeMinscrisClickOnSm () {
      navigateTo({ name: 'Experts' })
    },
    jeMinscrisClickOnXs () {
      navigateTo({ name: 'Experts' })
    },
    // // ** EXAMPLE ** //
    myCustomAction () {
      // console.debug(this.$id)
    },
    beforeMount () {
    },
    async mounted () {
      // // ** EXAMPLE ** //
      // // custom action like fetching data
      // const response = await axios.get('https://backend-url/my-api/endpoint')
      // this.$emailInput = response.data.email
    },
    beforeUnmount () {
    },
    unmounted () {
    }
  }
})
